import { GridCellValue } from '@mui/x-data-grid'

/**
 * Function that uses a string route to construct a detail route
 */
export const buildDetailRoute = (id: GridCellValue, route: string) => {
  return `${route.substring(0, route.indexOf(':'))}${id}`
}
